namespace $ {

	export function $shm_prereleasefixtureshared_message() {
		return 'Registry prerelease fixture'
	}

}
